import { useContext } from 'react';

import { PlatformType } from '@src/constants/request-data';
import { Store } from '@src/store';
import { convertDateByTimeZone } from '@src/utils';

import { useGetProductCode } from './use-get-product-code';
import { useGetProductName } from './use-get-product-name';
import { useRequest } from './use-request';

interface CustomerEventRegisterResponse {
  requestId: string;
  success: boolean;
  eventTime: string;
  eventCount: number;
}

export const useCustomerEventRegister = ({
  eventCode,
  contextData,
}: {
  eventCode: string;
  contextData?: Record<string, string | undefined | null>;
}) => {
  const {
    state: {
      stateAuth: { authTokens, phoneNumber },
      stateOrder: { themeValue },
    },
  } = useContext(Store);

  const productCode = useGetProductCode();
  const productName = useGetProductName();

  const { refetch } = useRequest<CustomerEventRegisterResponse>(
    `customerEventRegister_${eventCode}`,
    'post',
    '/v4/customer/event/register',
    {
      events: [
        {
          eventCode,
          contextData: {
            partnerName: themeValue,
            phone: phoneNumber,
            productCode,
            productName,
            source: PlatformType,
            ...contextData,
          },
          eventDatetime: convertDateByTimeZone(new Date())?.toISOString(),
        },
      ],
    },
    [
      eventCode,
      contextData,
      authTokens?.authorization?.accessToken,
      phoneNumber,
      themeValue,
      productCode,
      productName,
    ],
    true,
    authTokens?.authorization?.accessToken
  );

  return { refetch };
};
